import {
    Dialog,
    DialogActions,
    DialogContent,
    FormControlLabel,
    makeStyles,
    TextField,
    Typography
} from "@material-ui/core";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";
import {material_icons_groups} from "../../../../../icons/material_icons";
import IconComponent from "../../../../../Components/JsonScreen/Screen/ScreenComponents/IconComponent";
import InfiniteScroll from 'react-infinite-scroller';
import {useEffect, useState, useMemo} from "react";
import Button from "@material-ui/core/Button";
import {debounce} from "lodash";
import clsx from "clsx";
import DialogTitle from "@material-ui/core/DialogTitle";

const useStyles = makeStyles(() => ({
    container: {
        display: "flex",
    },
    selectTypeContainer: {
        width: '200px',
        background: '#f7f7f7',
        paddingLeft: 15,
        paddingTop: 10,
    },
    iconsContainer: {
        display: "flex",
        flexDirection: "column",
        width: 'calc(100% - 200px)',
        gap: 25,
        padding: 15
    },
    iconsGridContainer: {
        height: 300,
        overflow: 'auto',
    },
    iconsGrid: {
        display: 'grid',
        gap: 10,
        gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr',
    },
    iconItem: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
        padding: '3px 0',
        borderRadius: 8,
        '&:hover': {
            background: '#f7f7f7'
        }
    },
    iconItemSelected: {
        background: '#f7f7f7',
        border: '1px solid #dedede',
    }
}))
const PAGE_SIZE = 300;

const IconsSelectionModal = ({isOpen, onClose, onSubmit, value = {}}) => {
    const classes = useStyles();
    const {icon: sourceIcon, iconType: sourceIconType} = value;
    const [isLoading, setIsLoading] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [searchValue, setSearchValue] = useState("");
    const [foundIcon, setFoundIcon] = useState({onPage: null, id: null});
    const [scrollDone, setScrollDone] = useState(false);
    const [data, setData] = useState({content: [], totalPages: 0});
    const [page, setPage] = useState(1);
    const [iconType, setIconType] = useState('symbols-outlined');
    const [icon, setIcon] = useState(null);

    // Helper for scrolling to icon
    const scrollToIcon = (id) => {
        setTimeout(() => {
            const container = document.getElementById('iconGridContainer');
            const iconElement = document.getElementById(id);
            if (container && iconElement) {
                iconElement.scrollIntoView({
                    behavior: 'auto',
                    block: 'start',
                });
            }
        }, 500);
    };

    useEffect(() => {
        if (isOpen) {
            setIcon(sourceIcon);
            if (sourceIcon && sourceIconType && !scrollDone) {
                let found = findChosenIcon(sourceIcon, sourceIconType);
                if (found.onPage) setPage(found.onPage);
                setFoundIcon(found);
            }

            loadData(page, PAGE_SIZE, iconType, searchText);
            if (foundIcon.id && !scrollDone) {
                scrollToIcon(foundIcon.id);
                setFoundIcon({
                    onPage: null,
                    id: null,
                });
                setScrollDone(true)
            }
        }
        if (!isOpen) {
            setData({
                content: [],
                totalPages: 0
            });
            setSearchText("");
            setSearchValue("");
            setFoundIcon({
                onPage: null,
                id: null,
            });
            setScrollDone(false)
            setPage(1);
        }
    }, [isOpen, sourceIcon, sourceIconType, page, iconType, searchText, foundIcon.id]);

    const findChosenIcon = (icon, iconType) => {
        let iconsByType = material_icons_groups.filter(icon => {
            return !icon.unsupported_families.includes(getFamilyName(iconType));
        });
        let foundIndex = iconsByType.findIndex(iconS => iconS.id === icon);
        if (foundIndex === -1) {
            return {
                onPage: null,
                id: null
            };
        }
        return {
            onPage: Math.ceil(foundIndex / PAGE_SIZE),
            id: iconsByType[foundIndex].id
        };
    };

    const loadData = (page, pageSize, iconType, searchText) => {
        const lowerSearch = searchText.toLowerCase();
        const filtered = material_icons_groups.filter(icon => {
            const matchesType = !icon.unsupported_families.includes(getFamilyName(iconType));
            const matchesSearch =
                icon.name.toLowerCase().includes(lowerSearch) ||
                icon.tags.some(tag => tag.toLowerCase().includes(lowerSearch));
            return matchesType && matchesSearch;
        });
        setData({
            content: filtered.slice(0, pageSize * page),
            totalPages: Math.ceil(filtered.length / pageSize),
        });
    };

    const getFamilyName = (type) => {
        switch (type) {
            case 'regular':
                return 'Material Icons';
            case 'outlined':
                return 'Material Icons Outlined';
            case 'symbols-outlined':
                return 'Material Icons Round';
            case 'symbols-rounded':
                return 'Material Icons Sharp';
            default:
                return '';
        }
    };

    const loadMore = () => {
        if (!isLoading) {
            setIsLoading(true);
            setPage(prev => prev + 1);
            setTimeout(() => {
                setIsLoading(false);
            }, 500);
        }
    };

    const onChangeIconType = (e) => {
        setIconType(e.target.value);
        setIcon(null);
    };

    const onChangeIcon = (icon) => {
        setIcon(icon);
    };

    // Debounced search handler
    const debouncedSearch = useMemo(() => debounce((val) => {
        setSearchText(val);
    }, 1000), []);

    const onChangeSearch = (e) => {
        debouncedSearch(e.target.value);
        setSearchValue(e.target.value);
    };

    const handleSubmit = () => {
        (icon && iconType) && onSubmit(icon, iconType);
    };

    const handleDoubleClick = (iconSelected) => {
        (iconSelected && iconType) && onSubmit(iconSelected, iconType);
    };

    return (
        <Dialog onClose={onClose} open={isOpen} maxWidth={'md'} fullWidth={true}>
            <DialogTitle style={{padding: '10px 15px'}}>
                <Typography>
                    Icon Select
                </Typography>
            </DialogTitle>
            <DialogContent dividers style={{padding: 0}}>
                <div className={classes.container}>
                    <div className={classes.selectTypeContainer}>
                        <RadioGroup onChange={onChangeIconType} value={iconType}>
                            <FormControlLabel value="symbols-outlined" control={<Radio size={'small'}/>}
                                              label="Symbols Outlined"/>
                            <FormControlLabel value="symbols-rounded" control={<Radio size={'small'}/>}
                                              label="Symbols Rounded"/>
                            <FormControlLabel value="regular" control={<Radio size={'small'}/>} label="Regular"/>
                            <FormControlLabel value="outlined" control={<Radio size={'small'}/>} label="Outlined"/>
                        </RadioGroup>
                    </div>
                    <div className={classes.iconsContainer}>
                        <div>
                            <TextField
                                placeholder={'search...'}
                                variant={'outlined'}
                                size={'small'}
                                fullWidth={true}
                                value={searchValue || ""}
                                onChange={onChangeSearch}
                                autoFocus={true}
                            />
                        </div>
                        <div className={classes.iconsGridContainer} id={'iconGridContainer'}>
                            <InfiniteScroll
                                loadMore={loadMore}
                                hasMore={page < data.totalPages}
                                dataLength={data.content.length}
                                pageStart={1}
                                useWindow={false}
                            >
                                <div className={classes.iconsGrid}>
                                    {data.content.map((item, i) => {
                                        let isSelected = item.id === icon
                                        return (
                                            <div
                                                className={clsx(classes.iconItem, {[classes.iconItemSelected]: isSelected})}
                                                onClick={() => onChangeIcon(item.id)} key={i}
                                                onDoubleClick={() => {
                                                    handleDoubleClick(item.id)
                                                }}
                                                id={item.id}
                                            >
                                                <IconComponent
                                                    component={{
                                                        properties: {
                                                            iconType: iconType,
                                                            icon: item.id
                                                        },
                                                        styles: [{
                                                            fontSize: '2.2rem',
                                                        }]
                                                    }}

                                                />
                                                <Typography style={{fontSize: 11}} color={"textSecondary"}
                                                            align={'center'}>
                                                    {item.name}
                                                </Typography>
                                            </div>
                                        )
                                    })}
                                </div>
                            </InfiniteScroll>
                        </div>
                    </div>
                </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleSubmit} variant="contained" size={'small'} color={"primary"}
                        disabled={Boolean(!icon || !iconType)}
                >
                    Submit
                </Button>
                <Button onClick={onClose}
                        variant="contained" size={'small'}
                >
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default IconsSelectionModal